import * as React from "react";
import { Stack, Box, Text, Grid, ResponsiveContext } from "grommet";
import { first, orderBy, size } from "lodash";
import { useNavigate } from "react-router-dom";
import { SeasonMatchViewModel } from "./SeasonsStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RenderOutcome } from "../matches/OutcomeRenderer";
import { TeamName } from "../teams/TeamName";
import { TeamViewModel, getTeam } from "../teams/TeamsStore";
import Avatar from "react-avatar";
import { MatchOutcomeViewModel } from "../matches/MatchesStore";

export const SeasonMatchLine = ({ seasonMatch, teams, onClick }: { seasonMatch: SeasonMatchViewModel; teams: TeamViewModel[]; onClick?: () => void }) => {
    const [teamOne, setTeamOne] = React.useState({} as TeamViewModel);
    const [teamTwo, setTeamTwo] = React.useState({} as TeamViewModel);

    const [teamOneOutcome, setTeamOneOutcome] = React.useState({} as MatchOutcomeViewModel);
    const [teamTwoOutcome, setTeamTwoOutcome] = React.useState({} as MatchOutcomeViewModel);

    let [participantOne, participantTwo] = [seasonMatch.participantTeamIDs[0], seasonMatch.participantTeamIDs[1]];

    const tryGetTeam = (id) => {
        return new Promise<TeamViewModel>((resolve) => {
            let team = teams.find((x) => x.id == id);
            if (team) return resolve(team);
            return getTeam(id).then((result) => resolve(result.data.result));
        });
    };

    React.useEffect(() => {
        if (seasonMatch.match) {
            setTeamOne(seasonMatch.match.participants[0]?.team || {});
            setTeamOneOutcome(first(orderBy(seasonMatch.match.participants[0]?.outcomes || [], ["timestamp"], ["desc"])) || ({} as MatchOutcomeViewModel));
        } else {
            tryGetTeam(participantOne).then((result) => {
                setTeamOne(result);
            });
        }
    }, [participantOne]);

    React.useEffect(() => {
        if (seasonMatch.match) {
            setTeamTwo(seasonMatch.match.participants[1]?.team || {});
            setTeamTwoOutcome(first(orderBy(seasonMatch.match.participants[1]?.outcomes || [], ["timestamp"], ["desc"])) || ({} as MatchOutcomeViewModel));
        } else {
            tryGetTeam(participantTwo).then((result) => {
                setTeamTwo(result);
            });
        }
    }, [participantTwo]);

    let navigate = useNavigate();

    const navigationProps = seasonMatch.matchID && !onClick ? { hoverIndicator: "background-front", onClick: () => navigate("/matches/" + seasonMatch.matchID) } : { onClick: onClick };

    const size = React.useContext(ResponsiveContext);

    return (
        <Box {...navigationProps} style={{ position: "relative", overflow: "hidden" }} background="background-back" border={{ color: "text" }}>
            {size == "large" && (
                <>
                    <Avatar src={teamOne.logoUri} name={teamOne.name} size="85px" alt="" style={{ position: "absolute", left: -30, top: -10, opacity: "0.5" }} />
                    <Avatar src={teamTwo.logoUri} name={teamTwo.name} size="85px" alt="" style={{ position: "absolute", right: -30, top: -10, opacity: "0.5" }} />
                </>
            )}
            <Stack anchor="top" guidingChild={1} style={{ overflow: "hidden" }}>
                {(seasonMatch.match?.outcomes?.length || 0) == 0 && (
                    <Box gap="small" align="center" justify="center">
                        <>
                            <Box pad={"small"}>
                                <Text size={size} color={"background-front"}>
                                    VS
                                </Text>
                            </Box>
                        </>
                    </Box>
                )}
                {seasonMatch.match && seasonMatch.match?.outcomes?.length > 0 && (
                    <Box direction="row" align="start" style={{ height: "50px" }}>
                        <RenderOutcome outcome={teamOneOutcome} size="small"></RenderOutcome>
                        <RenderOutcome outcome={teamTwoOutcome} size="small" reverse></RenderOutcome>
                    </Box>
                )}
                <Stack anchor="top-left" guidingChild={0} style={{ overflow: "hidden" }}>
                    <Box pad="1.1rem" style={{ position: "relative" }} title={teamOne.name + " vs " + teamTwo.name}>
                        <Grid columns={["1/2", "1/2"]} rows={["auto"]}>
                            <Box direction="row" align="center" justify="start" gap="4px">
                                <TeamName team={teamOne} size={"xsmall"} color={""} border></TeamName>
                            </Box>

                            <Box direction="row" align="center" justify="end" gap="4px">
                                <TeamName team={teamTwo} size={"xsmall"} color={""} border></TeamName>
                            </Box>
                        </Grid>
                    </Box>
                    <Box direction="row" align="center" justify="center">
                        <Box pad={{ horizontal: "0.5rem", vertical: "0.25rem" }}>
                            <Text size="small" style={{ fontWeight: "bold" }}>
                                {seasonMatch.seasonMatchID}
                            </Text>
                        </Box>
                    </Box>
                </Stack>
            </Stack>
        </Box>
    );
};
